import { toMs } from "@/lib/timestamp";

const LONG_CLOCK_IN_WARNING_THRESHOLD_MS = 12 * 60 * 60 * 1000;

export function getClockedInDurationMs(
  clockedInAt: string | undefined,
  now: Date,
): number | null {
  if (!clockedInAt) return null;

  const durationMs = now.getTime() - toMs(clockedInAt);
  return durationMs > LONG_CLOCK_IN_WARNING_THRESHOLD_MS ? durationMs : null;
}

export function formatClockedInDuration(durationMs: number): string {
  const totalMinutes = Math.max(0, Math.floor(durationMs / 60000));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const hourLabel = `${hours} ${hours === 1 ? "hour" : "hours"}`;
  if (minutes === 0) return hourLabel;

  return `${hourLabel} ${minutes} ${minutes === 1 ? "minute" : "minutes"}`;
}
